<!-- Sub category row -->
<div class="sub-category row" *ngIf="subcategory$ | async as subcategory">
    <!-- General info -->
    <div class="cell code" [class.hidden]="columns['code'].hidden"
        [style.width]="columns['code'].width | percent:'1.0-6'">
        {{ subcategory.code }}
    </div>
    <div class="cell description" [class.hidden]="columns['description'].hidden"
        [style.width]="columns['description'].width | percent:'1.0-6'">
        <div class="content">{{ subcategory.description }}</div>
    </div>
    <div class="cell quantity" [class.hidden]="columns['quantity'].hidden"
        [style.width]="columns['quantity'].width | percent:'1.0-6'"></div>
    <div class="cell unit" [class.hidden]="columns['unit'].hidden"
        [style.width]="columns['unit'].width | percent:'1.0-6'"></div>

    <!-- Hours -->
    <div class="cell hour-norm" [class.hidden]="columns['hour-norm'].hidden"
        [style.width]="columns['hour-norm'].width | percent:'1.0-6'"></div>
    <div class="cell hour-net" [class.hidden]="columns['hour-net'].hidden"
        [style.width]="columns['hour-net'].width | percent:'1.0-6'"></div>
    <div class="cell wage-net" [class.hidden]="columns['wage-net'].hidden"
        [style.width]="columns['wage-net'].width | percent:'1.0-6'"></div>
    <div class="cell hour-percent" [class.hidden]="columns['hour-percent'].hidden"
        [style.width]="columns['hour-percent'].width | percent:'1.0-6'"></div>
    <div class="cell hour-gross" [class.hidden]="columns['hour-gross'].hidden"
        [style.width]="columns['hour-gross'].width | percent:'1.0-6'"></div>

    <!-- Materials -->
    <div class="cell material-norm" [class.hidden]="columns['material-norm'].hidden"
        [style.width]="columns['material-norm'].width | percent:'1.0-6'"></div>
    <div class="cell material-net" [class.hidden]="columns['material-net'].hidden"
        [style.width]="columns['material-net'].width | percent:'1.0-6'"></div>
    <div class="cell material-percent" [class.hidden]="columns['material-percent'].hidden"
        [style.width]="columns['material-percent'].width | percent:'1.0-6'"></div>
    <div class="cell material-gross" [class.hidden]="columns['material-gross'].hidden"
        [style.width]="columns['material-gross'].width | percent:'1.0-6'"></div>

    <!-- Equipment -->
    <div class="cell equipment-norm" [class.hidden]="columns['equipment-norm'].hidden"
        [style.width]="columns['equipment-norm'].width | percent:'1.0-6'"></div>
    <div class="cell equipment-net" [class.hidden]="columns['equipment-net'].hidden"
        [style.width]="columns['equipment-net'].width | percent:'1.0-6'"></div>
    <div class="cell equipment-percent" [class.hidden]="columns['equipment-percent'].hidden"
        [style.width]="columns['equipment-percent'].width | percent:'1.0-6'"></div>
    <div class="cell equipment-gross" [class.hidden]="columns['equipment-gross'].hidden"
        [style.width]="columns['equipment-gross'].width | percent:'1.0-6'"></div>

    <!-- Subcontracting -->
    <div class="cell subcontracting-norm" [class.hidden]="columns['subcontracting-norm'].hidden"
        [style.width]="columns['subcontracting-norm'].width | percent:'1.0-6'"></div>
    <div class="cell subcontracting-net" [class.hidden]="columns['subcontracting-net'].hidden"
        [style.width]="columns['subcontracting-net'].width | percent:'1.0-6'"></div>
    <div class="cell subcontracting-percent" [class.hidden]="columns['subcontracting-percent'].hidden"
        [style.width]="columns['subcontracting-percent'].width | percent:'1.0-6'"></div>
    <div class="cell subcontracting-gross" [class.hidden]="columns['subcontracting-gross'].hidden"
        [style.width]="columns['subcontracting-gross'].width | percent:'1.0-6'"></div>

    <!-- Totals -->
    <div class="cell norm total" [class.hidden]="columns['total-norm'].hidden"
        [style.width]="columns['total-norm'].width | percent:'1.0-6'"></div>
    <div class="cell net total" [class.hidden]="columns['total-net'].hidden"
        [style.width]="columns['total-net'].width | percent:'1.0-6'">{{ subcategory.aggregation?.all.net |
        currency:'EUR':'':null:'nl' }}</div>
    <div class="cell gross total" [class.hidden]="columns['total-gross'].hidden"
        [style.width]="columns['total-gross'].width | percent:'1.0-6'">{{ subcategory.aggregation?.all.gross |
        currency:'EUR':'':null:'nl' }}</div>
</div>